declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';






@Component({
  selector: 'branches',
  templateUrl: './branches.component.html',
  styleUrls: [
    './branches.component.scss']
  , animations: [routerTransition()]
})

export class BranchesComponent implements OnInit {

  
  public ShowList: boolean = true;
  public AddBranch: boolean = false;
  public EditBranch: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
  public searchText: any;
  public ApiResData: ApiResponseModel;



  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService) { }

  ngOnInit() {



  }

  AddNewBranch() {
    this.ShowList = false;
    this.AddBranch = true;
    this.EditBranch = false;
  }
  EditBranc() {
    this.ShowList = false;
    this.AddBranch = false;
    this.EditBranch = true;
  }
  Cancel() {
    this.ShowList = true;
    this.AddBranch = false;
    this.EditBranch = false;
  }
  registration() {
    let m = document.querySelector("#registration");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  reports() {
    let m = document.querySelector("#reports");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  cards() {
    let m = document.querySelector("#cards");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  address() {
    let m = document.querySelector("#address");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


}
